import { gql } from '@apollo/client'

export const SOLVE_CONFLICT = gql`
  mutation SolveConflict($input: SolveInput!) {
    solveConflict(input: $input) {
      message
    }
  }
`
